module.exports = __webpack_public_path__ + "img/znpp.9a2ebb3.png";